import React from 'react';

import HookupbayMembers from './members'
import Mids from './mids'
import Refunds from './refunds'
import Chargebacks from './chargebacks'

const Tabs = {
  Sales: HookupbayMembers,
  Mids: Mids,
  Refunds: Refunds,
  Chargebacks: Chargebacks
}

class Component extends React.Component {

  openTab = (tab,e) => {
    if (tab != this.props.state.tab) {
      this.props.setState({tab})
    }
    e && e.preventDefault()
  }

  render() {
    let tabs = Object.keys(Tabs);
    let currentTab = this.props.currentTab
    let Component = Tabs[currentTab]
    return (
      <div>
        <div class="nav-active-primary b-b b-primary">
          <ul class="nav nav-tabs">
            {tabs.map((tab) =>
              <li key={tab} class="nav-item">
                <a class={"nav-link "+(currentTab == tab ? "active " : "")} onClick={e => this.openTab(tab,e)}>
                    <span>{tab}</span>
                </a>
              </li>
            )}
          </ul>
        </div>
        <div class="tab-content">                
            <div class="tab-pane pt-3 active">
              <Component />
            </div>
        </div>
      </div>
    );
  }
}

import api from 'src/actions/api'
import setState from 'src/actions/state'
import { connect } from 'react-redux'

export default connect(({ state }) => ({
  state: state["hookupbay"] || state.initial,
  currentTab: state.hookupbay && state.hookupbay.tab || "Sales"
}), {
  api, 
  setState: setState("hookupbay")
})(Component)  